import { Inject, Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable } from "rxjs";
import { filter, mergeMap } from "rxjs/operators";

import { RouteConfig, ROUTER_CONFIG, RouterConfig } from "../config/router-config.model";

import { LazyLoadingService } from "./lazy-loading.service";

/** @internal */
@Injectable({
	providedIn: "root",
})
export class ObgPreloadingStrategy implements PreloadingStrategy {
	constructor(
		private lazyLoadingService: LazyLoadingService,
		@Inject(ROUTER_CONFIG) private config: RouterConfig
	) {}

	/**
	 * Angular's `PreloadingStrategy` implementation.
	 */
	preload(route: Route, load: () => Observable<any>): Observable<any> {
		if (this.config.preloadAllLazyModules) {
			return load();
		}

		return this.lazyLoadingService.getPreload$().pipe(
			filter((name) => (route as RouteConfig).name === name && !this.lazyLoadingService.getModuleStatus(name)),
			mergeMap(load)
		);
	}
}
